import { cardTreatmentAllowed } from './tomo-card-experiment.js';
import { CartUpdateEvent } from '@theme/events';
import { matchingVariants, selectedVariant, optionState } from './tomo-card-selection.js';
class TomoCardBuy extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    if (this.dataset.experiment) {
      if (!cardTreatmentAllowed(window.igData?.user, this.dataset.experiment)) {
        if (!this.waitingForIg) {
          this.waitingForIg = true;
          window.addEventListener('ig:ready', () => { if (this.isConnected) this.connectedCallback(); }, { once: true });
        }
        return;
      }
      document.documentElement.dataset.tomoCardTreatment = '';
    }
    this.variants = JSON.parse(this.querySelector('[data-card-variants]').textContent);
    this.groups = [...this.querySelectorAll('[data-option-index]')];
    this.selected = this.groups.map(group => group.hidden ? group.querySelector('[data-value]').dataset.value : null);
    this.addButton = this.querySelector('[data-card-add]');
    this.status = this.querySelector('[data-card-status]');
    this.busy = false;
    this.addEventListener('click', event => {
      event.stopPropagation();
      const choice = event.target.closest('[data-value]');
      if (choice && !choice.disabled && !this.busy) {
        const index = Number(choice.closest('[data-option-index]').dataset.optionIndex);
        this.selected[index] = choice.dataset.value;
        this.groups.forEach((group, i) => { if (i > index && !group.hidden) this.selected[i] = null; });
        this.status.textContent = '';
        this.update();
        const variant = matchingVariants(this.variants, this.selected).find(v => v.available && v.image);
        const image = this.closest('product-card')?.querySelector('.card-gallery img');
        if (image && variant?.image) { image.src = variant.image; image.removeAttribute('srcset'); }
      }
      if (event.target.closest('[data-card-add]')) this.add();
    });
    this.dataset.ready = 'true';
    this.update();
  }
  update() {
    for (const [index, group] of this.groups.entries()) {
      for (const button of group.querySelectorAll('[data-value]')) {
        const state = optionState(this.variants, this.selected, index, button.dataset.value);
        button.disabled = this.busy || !state.available;
        button.setAttribute('aria-pressed', String(this.selected[index] === button.dataset.value));
        button.classList.toggle('tomo-choice--low', Boolean(state.low));
        button.querySelector('[data-choice-stock]').textContent = state.low ? `${state.low} left` : '';
        button.setAttribute('aria-label', `${button.dataset.value}${!state.available ? ' — sold out' : state.low ? ` — ${state.low} left` : ''}`);
      }
    }
    this.variant = selectedVariant(this.variants, this.selected);
    this.addButton.disabled = this.busy || !this.variant;
    const missing = this.groups.filter((g,i) => this.selected[i] == null).map(g => g.dataset.optionName.toLowerCase());
    this.addButton.textContent = this.busy ? 'Adding…' : this.variant ? `Add${this.variant.min > 1 ? ` ${this.variant.min}` : ''} · ${this.variant.price}${this.variant.min > 1 ? ' each' : ''}` : `Choose ${missing.join(' & ') || 'an available option'}`;
  }
  async add() {
    if (this.busy || !this.variant) return;
    const variant = this.variant;
    this.busy = true;
    this.status.textContent = '';
    this.update();
    let added = false;
    const root = this.dataset.root.replace(/\/?$/, '/');
    try {
      const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean))].slice(0,5);
      const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:variant.min || 1}],sections,sections_url:location.pathname})});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : 'This option could not be added. Please check availability.');
      added = true;
      this.status.textContent = 'Added ✓';
      const cartResponse = await fetch(root + 'cart.js', {headers:{'Accept':'application/json'}});
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('tomo:cart-updated', {detail:{cart,open:false}}));
        this.dispatchEvent(new CartUpdateEvent(cart, String(variant.id), {source:'tomo-card-buy',itemCount:cart.item_count,productId:this.dataset.productId,variantId:String(variant.id),sections:result.sections}));
      }
    } catch (error) {
      this.status.textContent = added ? 'Added ✓ — open cart to review.' : (error instanceof TypeError ? 'Connection interrupted. Check your cart before trying again.' : error.message);
    } finally {
      this.busy = false;
      this.update();
    }
  }
}
if (!customElements.get('tomo-card-buy')) customElements.define('tomo-card-buy', TomoCardBuy);

